import { Route, withRouter, Switch, Redirect } from 'react-router-dom';
import SideNavigationBar from 'components/SidebarNav/Sidebar';
import TopNavigationBar from 'components/navbars/NavigationBar';
import Footer from 'components/footer';
import { ProtectedRoute } from 'components/ProtectedRoute';
import AdminRoutes from 'components/RouteComponent/AdminRoutes';
// pages
import LoginPage from 'views/login/LoginPage';
import UserPage from 'views/users/UserPage';
import CreateUserPage from 'views/users/CreateUserPage';
import RolesPage from 'views/role/RolePage';
import ForgotPassword from 'views/login/ForgotPassword';
import CreateFieldSchema from 'views/Data/CreateFieldSchema';
import FieldSchemaPage from 'views/Data/FieldSchemaPage';
import CreateStepPage from 'views/Data/CreateStepPage';
import StepListPage from 'views/Data/StepListPage';
import ProgramTracker from 'views/ProgramTracker/ProgramTracking';
import CreateBomPage from 'views/BOM/CreateBomPage';
import BomListPage from 'views/BOM/BomListPage';
import PoListPage from 'views/PO/PoListPage';
import AdminDashboardPage from 'views/Program/AdminDashboardPage';
import CustomerListPage from 'views/Customer/CustomerDashboardPage';
import StdProcessPage from 'views/Data/StdProcessPage';
import CreateStdProcessPage from 'views/Data/CreateStdProcessPage';
import CreateCustomerPage from 'views/Customer/CreateCustomerPage';
import BusinessVerticalPage from 'views/Settings/BusinessVertical';
import RegionTablesPage from 'views/Settings/RegionTables';
import ComponentPartsPage from 'views/Settings/ComponentParts';
import QuotationSettingsPage from 'views/Settings/QuotationSettingsPage';
import HistoryPage from 'views/HistoryPage';
import ManufacturingUpdate from 'views/Manufacturing/ManufacturingUpdate';
import DeliveryTrailDashboard from 'views/DeliveryTrail/DeliveryTrailDashboard';
import CreateDeliveryTrail from 'views/DeliveryTrail/CreateDeliveryTrail';
import CreateEnquiry from 'views/Enquiry/CreateEnquiryPage';
import EnquiryListPage from 'views/Enquiry/EnquiryListPage';
import CreatePoPage from 'views/PO/CreatePoPage';

// import ProjectSummary from "views/Program/ProjectSummary";

const BomListPageWrapper = (props) => {
    return <BomListPage {...props} />;
};

const CreateUserPageWrapper = (props) => {
    return <CreateUserPage {...props} />;
};

const CreateFieldSchemaWrapper = (props) => {
    return <CreateFieldSchema {...props} />;
};

const FieldSchemaPageWrapper = (props) => {
    return <FieldSchemaPage {...props} />;
};

const CreateStepPageWrapper = (props) => {
    return <CreateStepPage {...props} />;
};

const StepListPageWrapper = (props) => {
    return <StepListPage {...props} />;
};

const ProgramTrackerWrapper = (props) => {
    return <ProgramTracker {...props} />;
};

const CreateBomPageWrapper = (props) => {
    return <CreateBomPage {...props} />;
};

// const CandidateManagementPageWrapper = props => {
//     return <CandidateManagementPage {...props} />;
// };

const AdminDashboardPageWrapper = (props) => {
    return <AdminDashboardPage {...props} />;
};

const CustomerListPageWrapper = (props) => {
    return <CustomerListPage {...props} />;
};

const CreateCustomerPageWrapper = (props) => {
    return <CreateCustomerPage {...props} />;
};
// const PartnerDashboardPageWrapper = props => {
//     return <PartnerDashboardPage {...props} />;
// };

// const AttendanceModulePageWrapper = props => {
//     return <AttendanceModulePage {...props} />;
// }

// const AttendanceReportPageWrapper = props => {
//     return <AttendanceReportPage {...props} />;
// }

// const ProjectSummaryWrapper = props => {
//     return <ProjectSummary {...props} />;
// }
const StdProcessPageWrapper = (props) => {
    return <StdProcessPage {...props} />;
};
const CreateStdProcessPageWrapper = (props) => {
    return <CreateStdProcessPage {...props} />;
};
const BusinessVerticalPageWrapper = (props) => {
    return <BusinessVerticalPage {...props} />;
};
const RegionTablesPageWrapper = (props) => {
    return <RegionTablesPage {...props} />;
};
const ComponentPartsPageWrapper = (props) => {
    return <ComponentPartsPage {...props} />;
};
const QuotationSettingsPageWrapper = (props) => {
    return <QuotationSettingsPage {...props} />;
};
const HistoryPageWrapper = (props) => {
    return <HistoryPage {...props} />;
};

export const RouterComponent = withRouter(({ location, history }) => {
    return (
        <div className="app-container">
            <div className="header-container top-navigation-bar-container">
                {
                    // (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === '/forget-password') ? "" : <TopNavigationBar history={history} />
                    <TopNavigationBar history={history} />
                }
            </div>
            <div className="side-navigation-bar-container">
                {
                    // (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === '/forget-password') ? "" : <SideNavigationBar history={history} />
                    <SideNavigationBar history={history} />
                }
            </div>
            <div className="main-container">
                <Switch>
                    <Route path="/login-page" render={(props) => <LoginPage {...props} />} />
                    <Route
                        path="/forget-password"
                        render={(props) => <ForgotPassword {...props} />}
                    />
                    <AdminRoutes path="/user-page" component={UserPage} />
                    <AdminRoutes path="/create-user-page" component={CreateUserPageWrapper} />
                    <AdminRoutes path="/roles-page" component={RolesPage} />
                    <AdminRoutes
                        exact
                        path="/create-field-schema-page"
                        component={CreateFieldSchemaWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/field-schema-page"
                        component={FieldSchemaPageWrapper}
                    />
                    <ProtectedRoute exact path="/create-step-page" component={CreateStepPageWrapper} />
                    <ProtectedRoute exact path="/step-list-page" component={StepListPageWrapper} />
                    <ProtectedRoute
                        exact
                        path="/program-tracking/:id"
                        component={ProgramTrackerWrapper}
                    />
                    <ProtectedRoute exact path="/create-bom-page" component={CreateBomPageWrapper} />
                    <ProtectedRoute
                        exact
                        path="/create-bom-page/:id"
                        component={CreateBomPageWrapper}
                    />
                    <ProtectedRoute exact path="/bom-list" component={BomListPageWrapper} />
                    <ProtectedRoute
                        exact
                        path="/admin-dashboard-page"
                        component={AdminDashboardPageWrapper}
                    />
                    <ProtectedRoute
                        exact
                        path="/customer-list-page"
                        component={CustomerListPageWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/create-customer-page"
                        component={CreateCustomerPageWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/business-vertical-page"
                        component={BusinessVerticalPageWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/region-data-page"
                        component={RegionTablesPageWrapper}
                    />
                    <ProtectedRoute
                        exact
                        path="/component-parts-page"
                        component={ComponentPartsPageWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/quotation-settings-page"
                        component={QuotationSettingsPageWrapper}
                    />
                    <ProtectedRoute exact path="/std-process-page" component={StdProcessPageWrapper} />
                    <ProtectedRoute
                        exact
                        path="/create-std-process-page"
                        component={CreateStdProcessPageWrapper}
                    />
                    <AdminRoutes
                        exact
                        path="/audit-trail-page"
                        component={HistoryPageWrapper}
                    />
                    <ProtectedRoute    
                        exact
                        path="/manufacturing-quick-update"
                        component={ManufacturingUpdate}
                    />
                    <ProtectedRoute
                        exact
                        path="/delivery-trail-dashboard"
                        component={DeliveryTrailDashboard}
                    />
                    <ProtectedRoute
                        exact
                        path="/create-delivery-trail"
                        component={CreateDeliveryTrail}
                    />
                    <ProtectedRoute
                        exact
                        path="/create-delivery-trail/:bomId"
                        component={CreateDeliveryTrail}
                    />
                    <ProtectedRoute
                        exact
                        path="/create-enquiry"
                        component={CreateEnquiry}
                    />
                    <ProtectedRoute
                        exact
                        path="/po-list"
                        component={PoListPage}
                    />
                    <ProtectedRoute
                        exact path="/create-po/:id" 
                        component={CreatePoPage} 
                    />
                    <ProtectedRoute
                        exact
                        path="/create-enquiry/:id"
                        component={CreateEnquiry}
                    />
                    <ProtectedRoute
                         exact path="/enquiry-list" 
                         component={EnquiryListPage} 
                    />
                    <ProtectedRoute
                         exact path="/create-po/:id" 
                         component={CreatePoPage} 
                    />
                    {/* <AdminRoutes exact path="/project-summary" component={ProjectSummaryWrapper} /> */}
                    <Redirect
                        to={{
                            pathname: '/login-page',
                            state: {
                                from: location,
                            },
                        }}
                    />
                </Switch>
            </div>
            <div className="footer-container">
                {
                    // (location.pathname === "/login-page" || location.pathname.includes("/login/") || location.pathname === "/" || location.pathname === "/forget-password") ? "" : <Footer />
                    <Footer />
                }
            </div>
        </div>
    );
});
